import About from './aboutContent.vue'
export default {
    About 
}